module.exports = __webpack_public_path__ + "img/dotted-circle-218.19beac39.svg";